// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.warning_pp3bJ {
    background: var( --color-danger050 );
    border: 1px solid var( --color-danger500 );
    padding: 8px;
    border-radius: 4px;
    margin: 0px 0px 24px;
}

.info_UtiEs {
  background: var( --color-brand025 );
  border: 1px solid var( --color-brand100 );
  padding: 8px;
  border-radius: 4px;
  margin: 0px 0px 24px;
}

.topText_tRSqo {
   margin: 0px 0px 24px;
}

.dialog_uZ8yI {
    background: var(--color-base050);
    box-shadow: 0px 0px 1px rgba(41, 50, 61, 0.32), 0px 16px 32px rgba(41, 50, 61, 0.16);
    border-radius: 4px;
    max-height: 410px;
}

.content_Zzzig {
    min-width: 496px;
    background: var(--color-base050) !important;
    padding: 24px !important;
}

.content2_VWC7l {
    min-width: 496px;
    background: var(--color-base050) !important;
}

.header_KwgdW {
    background: #FFFF !important;
    height: 48px;
    padding: 0px;
}

.footer_ivNxn {
    background: #FFFF !important;
}

.email_C0qXR {
    margin-top: 8px;
    margin-bottom: 24px;
}

.newEmail_MJiWF {
    margin-top: 8px;
}

.emailConfirm_CyGQE {
    padding-bottom: 8px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/actions/salesFlow/ChangeVehicleOwnership.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,0CAA0C;IAC1C,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;GACG,oBAAoB;AACvB;;AAEA;IACI,gCAAgC;IAChC,oFAAoF;IACpF,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,2CAA2C;IAC3C,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA;IACI,4BAA4B;IAC5B,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".warning {\n    background: var( --color-danger050 );\n    border: 1px solid var( --color-danger500 );\n    padding: 8px;\n    border-radius: 4px;\n    margin: 0px 0px 24px;\n}\n\n.info {\n  background: var( --color-brand025 );\n  border: 1px solid var( --color-brand100 );\n  padding: 8px;\n  border-radius: 4px;\n  margin: 0px 0px 24px;\n}\n\n.topText {\n   margin: 0px 0px 24px;\n}\n\n.dialog {\n    background: var(--color-base050);\n    box-shadow: 0px 0px 1px rgba(41, 50, 61, 0.32), 0px 16px 32px rgba(41, 50, 61, 0.16);\n    border-radius: 4px;\n    max-height: 410px;\n}\n\n.content {\n    min-width: 496px;\n    background: var(--color-base050) !important;\n    padding: 24px !important;\n}\n\n.content2 {\n    min-width: 496px;\n    background: var(--color-base050) !important;\n}\n\n.header {\n    background: #FFFF !important;\n    height: 48px;\n    padding: 0px;\n}\n\n.footer {\n    background: #FFFF !important;\n}\n\n.email {\n    margin-top: 8px;\n    margin-bottom: 24px;\n}\n\n.newEmail {\n    margin-top: 8px;\n}\n\n.emailConfirm {\n    padding-bottom: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"warning": `warning_pp3bJ`,
	"info": `info_UtiEs`,
	"topText": `topText_tRSqo`,
	"dialog": `dialog_uZ8yI`,
	"content": `content_Zzzig`,
	"content2": `content2_VWC7l`,
	"header": `header_KwgdW`,
	"footer": `footer_ivNxn`,
	"email": `email_C0qXR`,
	"newEmail": `newEmail_MJiWF`,
	"emailConfirm": `emailConfirm_CyGQE`
};
export default ___CSS_LOADER_EXPORT___;
